import { type UseFormReturn, useWatch } from 'react-hook-form';
import { useFormMethods } from '@hqo/multi-step-form';
import type { FieldConfig } from '../../../../hooks/use-ui-metadata-field-config.hook';
import type { CreateVisitFormV2Values } from '../../../../types/form-data.types';
import { InputField } from '../one-visitor/input-field';

interface NoteForVisitorProps {
  config: FieldConfig;
}

export const NoteForVisitor = ({ config }: NoteForVisitorProps): JSX.Element | null => {
  const form = useFormMethods() as unknown as UseFormReturn<CreateVisitFormV2Values>;
  const {
    register,
    control,
    formState: { errors },
  } = form;
  const value = useWatch({ control, name: 'checkInInstructions' });

  if (config.hidden) {
    return null;
  }

  return (
    <InputField
      id="checkInInstructions"
      name="checkInInstructions"
      register={register}
      error={errors.checkInInstructions}
      value={value ?? ''}
      labelKey="createVisitFormV2.visitStep.checkInInstructions"
      labelDefault="Note for visitor"
      required={config.required}
      placeholderKey="createVisitFormV2.visitStep.placeholders.checkInInstructions"
      placeholderDefault="e.g. Please check in at the front desk"
    />
  );
};
